import { ETH } from '@/utils/networks/types';

const SUPPORTED_NETWORKS = [ETH];

export { SUPPORTED_NETWORKS };
